import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-code-item-option-select',
  templateUrl: './code-item-option-select.component.html',
  styleUrls: ['./code-item-option-select.component.scss'],
})
export class CodeItemOptionSelectComponent {
  public keyword: string;
  public _selectedOption: string;

  @Input() items: { name: string; deletable: boolean }[];
  @Input() type: string;
  @Input() set selectedOption(option: string) {
    this._selectedOption = option;
  }

  @Output() action = new EventEmitter<{
    type: 'addOption' | 'deleteOption';
    codeItem: string;
    value: string;
  }>();

  resetKeyword(): void {
    this.keyword = null;
  }
}
